import React, { useState, useEffect } from "react";
import axios from "axios";
import { forwardRef } from "react";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { Input } from "@material-ui/core";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";

import Table from "../Tables/Table";
import "../App.css";

function RecordsSolo(props) {
  const [post, setPost] = useState();
  const { rank } = props.match.params;
  const { class_name } = props.match.params;
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };
  const [data, setData] = useState([]);
  const [showVideoOnly, setShowVideoOnly] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  // TODO: replace with the real video-only records endpoint once it exists
  const ALL_RECORDS_URL = `https://psucta.com/api/stats/solo/${rank}`;
  const VIDEO_RECORDS_URL = `https://psucta.com/api/stats/solo/verified/${rank}`;
  const refresh = () => window.location.reload(true)
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#ff9100",
      },
      secondary: {
        main: "#ff9100",
      },
      type: "dark",
    },
  });

  // console.log(data);
  console.log("Count: ", data);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setData([]);
      try {
        const result = await axios(showVideoOnly ? VIDEO_RECORDS_URL : ALL_RECORDS_URL);
        setData(result.data);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [rank, showVideoOnly]);

  return (
    <div className="App">
      
      <MuiThemeProvider theme={theme}>
      <div className="quest-rank">
      <Link to="/records/solo/8">Ultimate</Link>
      <Link to="/records/solo/7">S4</Link>
      <Link to="/records/solo/6">S3</Link>
      <Link to="/records/solo/5">S2</Link>      
              </div>
        <MaterialTable
          title={
            <div className="leaderboard-type">
              <h4>{showVideoOnly ? "Solo Records — All Classes" : "Solo Records — All Classes"}</h4>
              <div className="player-count">
              <Link to="/records/solo/8">Solo</Link>
              <Link to="/records/duo/8">Duo</Link>
              <Link to="/records/trio/8">Trio</Link>
              <Link to="/records/quad/8">Quad</Link>
              <Link to="/records/party/8">Party</Link>
              </div>
              <div className="video-toggle-wrapper">
              <label className="video-toggle-switch">
                <input
                  type="checkbox"
                  checked={showVideoOnly}
                  onChange={() => setShowVideoOnly((prev) => !prev)}
                />
                <span className="video-toggle-slider">
                  <span className="video-toggle-label">
                    {showVideoOnly ? "VERIFIED" : "UNVERIFIED"}
                  </span>
                </span>
              </label>
              </div>
              
              <div className="player-type">
              <Link to={`/records/solo/${rank}`}>All</Link>
              <Link to="/records/solo/Ultimate/Fighgunner">FI</Link>
              <Link to="/records/solo/Ultimate/Guntecher">GT</Link>
              <Link to="/records/solo/Ultimate/Wartecher">WT</Link>
              <Link to="/records/solo/Ultimate/Fortefighter">FF</Link>
              <Link to="/records/solo/Ultimate/Fortegunner">FG</Link>
              <Link to="/records/solo/Ultimate/Fortetecher">FT</Link>
              <Link to="/records/solo/Ultimate/Protranser">PT</Link>
              <Link to="/records/solo/Ultimate/Acrofighter">AF</Link>
              <Link to="/records/solo/Ultimate/Acrotecher">AT</Link>
              <Link to="/records/solo/Ultimate/Fighmaster">FM</Link>
              <Link to="/records/solo/Ultimate/Gunmaster">GM</Link>
              <Link to="/records/solo/Ultimate/Masterforce">MF</Link>
              <Link to="/records/solo/Ultimate/Acromaster">AM</Link>
              </div>
            </div>
          }
          columns={[
            {
              title: "",
              field: "profile_pictures",
              width: "100%",
              render: (rowData) => (
                <img
                  src={rowData.profile_picture}
                  style={{ width: 40, borderRadius: "50%" }}
                />
              ),
              filtering: false,
              sorting: false,
              searchable: false,
            },
            {
              title: "Player Names",
              field: "player_name",
              render: (rowData) => (
                <Link to={`/players/${rowData.player_id}`}>
                  {rowData.player_name}
                </Link>
              ),
              editComponent: (props) => (
                <Input
                  defaultValue={props.value || "null"}
                  onChange={(e) => props.onChange(e.target.value)}
                  type="string"
                />
              ),
            },
            {
              title: "Mission Name",
              field: "mission_name",
              render: (rowData) => (
                <Link to={`/missions/solo/${rowData.mission_name}`}>
                  {rowData.mission_name}
                </Link>
              ),
            },
            { title: "Rank", field: "rank_name" },
            { title: "Clear Time", field: "fastest_time" },
            {
              title: "Class Names",
              field: "player_class",
              render: (rowData) => (
                <Link to={`/records/solo/Ultimate/${rowData.player_class}`}>
                  {rowData.player_class}
                </Link>
              ),
            },
            
            { title: "Race", field: "player_race" },
            { title: "Enemies Killed", field: "enemies_killed" },
            // { title: "Patch", field: "patch" },
            {
              title: "Validation Type",
              field: "validation_type",
              render: (rowData) => (
                <Link to={`/runs/${rowData.run_id}`}>
                  {rowData.validation_type ? rowData.validation_type : "Mission Log"}
                </Link>
              ),
            },
            {
              title: "Date Added",
              field: "run_date",
              type: "date",
              cellStyle: {
                whiteSpace: 'nowrap'
               },
              render: (rowData) => {
                const date = new Date(rowData.run_date);
                // Add 6 hours to the date
                date.setHours(date.getHours());
                return date.toLocaleString();
              },
            },
          ]}
          data={data}
          icons={tableIcons}
          localization={{
            body: {
              emptyDataSourceMessage: isLoading ? (
                <span className="table-loading">
                  <span className="table-loading-spinner" />
                  Loading...
                </span>
              ) : "No records to display",
            },
          }}
          options={{
            filtering: true,
            paging: false,
            headerStyle: { fontWeight: 700 },
            paginationType: "stepped",
            rowStyle: {
              height: "50px",
            },
          }}
        />
      </MuiThemeProvider>
    </div>
  );
}

export default RecordsSolo;
